type BadgingNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>;
  clearAppBadge?: () => Promise<void>;
};

const normalizeBadgeCount = (count: number) =>
  Math.max(0, Math.floor(Number(count) || 0));

export const setWebAppBadge = async (count: number) => {
  if (typeof navigator === 'undefined') {
    return;
  }

  const badgingNavigator = navigator as BadgingNavigator;
  const normalizedCount = normalizeBadgeCount(count);

  try {
    if (normalizedCount === 0 && badgingNavigator.clearAppBadge) {
      await badgingNavigator.clearAppBadge();
    } else if (badgingNavigator.setAppBadge) {
      await badgingNavigator.setAppBadge(normalizedCount);
    }

    // Keep the service worker's background count aligned with the API total.
    navigator.serviceWorker?.controller?.postMessage({
      type: 'ADMIN_BADGE_COUNT',
      count: normalizedCount,
    });
  } catch (error) {
    // Badging is an optional installed-PWA capability.
    console.warn('Unable to update the PWA badge:', error);
  }
};

export const clearWebAppBadge = () => setWebAppBadge(0);
